export default __webpack_public_path__ + "static/media/anna@2x.11fc0bc4.png";